var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      icon: _vm.icon,
      show: _vm.dialog,
      maxWidth: "90%",
      showRequiredFields: false,
      showButton: false,
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-container",
              [
                _vm.isFormBlocked
                  ? _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12" } },
                          [
                            _c(
                              "v-alert",
                              {
                                attrs: {
                                  type: _vm.tokenExpired
                                    ? "warning"
                                    : _vm.alreadySigned
                                    ? "info"
                                    : "error",
                                  prominent: "",
                                  border: "left",
                                },
                              },
                              [
                                _c(
                                  "v-row",
                                  { attrs: { align: "center" } },
                                  [
                                    _c("v-col", { staticClass: "grow" }, [
                                      _c("strong", [
                                        _vm._v(_vm._s(_vm.blockMessage)),
                                      ]),
                                      _vm.tokenExpired
                                        ? _c(
                                            "div",
                                            { staticClass: "mt-2 text-body-2" },
                                            [
                                              _vm._v(
                                                " O prazo para acessar este link expirou. Entre em contato com a instituição para solicitar um novo link de acesso. "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.isFormBlocked
                  ? _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "12" } },
                          [
                            _vm.isPitDocument && _vm.content
                              ? _c("iframe", {
                                  ref: "pitFrame",
                                  staticClass: "pit-document-frame",
                                  attrs: {
                                    title:
                                      "Documento do Plano Individual de Trabalho (PIT)",
                                    srcdoc: _vm.content,
                                  },
                                  on: { load: _vm.resizePitFrame },
                                })
                              : _vm.content
                              ? _c("div", {
                                  domProps: { innerHTML: _vm._s(_vm.content) },
                                })
                              : _vm.isPitDocument
                              ? _c(
                                  "v-alert",
                                  {
                                    staticClass: "ma-0",
                                    attrs: {
                                      type: "warning",
                                      text: "",
                                      dense: "",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " Não foi possível carregar o documento do PIT. Entre em contato com a administração. "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.model && _vm.model.term && !_vm.isFormBlocked
                  ? _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "12" } },
                          [
                            _c("a", { attrs: { id: "term" } }),
                            _vm.termOptions && _vm.termOptions.length > 0
                              ? _c(
                                  "v-radio-group",
                                  {
                                    staticClass: "ma-2",
                                    attrs: { disabled: _vm.view },
                                    on: { change: _vm.onOptionChange },
                                    model: {
                                      value: _vm.model.term_option_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "term_option_id",
                                          $$v
                                        )
                                      },
                                      expression: "model.term_option_id",
                                    },
                                  },
                                  _vm._l(_vm.termOptions, function (opt, i) {
                                    return _c("v-radio", {
                                      key: opt.id || i,
                                      attrs: {
                                        label: opt.label,
                                        value: opt.id,
                                        color:
                                          opt.color ||
                                          (opt.is_valid_acceptance
                                            ? "success"
                                            : "grey"),
                                      },
                                    })
                                  }),
                                  1
                                )
                              : _vm.model.term.is_required
                              ? _c("v-checkbox", {
                                  staticClass: "ma-2",
                                  attrs: {
                                    label:
                                      _vm.model.term.label ||
                                      "Li e concordo com os termos acima",
                                    color: "primary",
                                    "hide-details": "",
                                    disabled: _vm.view,
                                  },
                                  model: {
                                    value: _vm.model.agree,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.model, "agree", $$v)
                                    },
                                    expression: "model.agree",
                                  },
                                })
                              : _c(
                                  "span",
                                  [
                                    _vm.institutionOptions &&
                                    _vm.institutionOptions.length > 0
                                      ? _c(
                                          "v-radio-group",
                                          {
                                            staticClass: "ma-2",
                                            attrs: {
                                              row: "",
                                              disabled: _vm.view,
                                            },
                                            on: { change: _vm.onOptionChange },
                                            model: {
                                              value: _vm.model.term_option_id,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  "term_option_id",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "model.term_option_id",
                                            },
                                          },
                                          _vm._l(
                                            _vm.institutionOptions,
                                            function (opt, i) {
                                              return _c("v-radio", {
                                                key: opt.id || i,
                                                attrs: {
                                                  label: opt.label,
                                                  value: opt.id,
                                                  color: opt.color,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showJustificationField && !_vm.isFormBlocked
                  ? _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "12" } },
                          [
                            _c("a", { attrs: { id: "justification" } }),
                            _c("v-textarea", {
                              attrs: {
                                label: "Justificativa *",
                                error: !!_vm.errors.justification,
                                "error-messages": _vm.errors.justification,
                                disabled: _vm.view,
                                counter: 2000,
                                rules: _vm.justificationRules,
                                rows: "4",
                                outlined: "",
                                "persistent-placeholder": "",
                                placeholder:
                                  "Informe o motivo da sua decisão...",
                                hint: "A justificativa é obrigatória para a opção selecionada (mínimo 10 caracteres)",
                                "persistent-hint": "",
                              },
                              model: {
                                value: _vm.model.justification,
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, "justification", $$v)
                                },
                                expression: "model.justification",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.view && _vm.model.justification
                  ? _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "12" } },
                          [
                            _c(
                              "v-card",
                              { staticClass: "pa-3", attrs: { outlined: "" } },
                              [
                                _c("v-card-subtitle", { staticClass: "pb-1" }, [
                                  _vm._v("Justificativa"),
                                ]),
                                _c("v-card-text", [
                                  _vm._v(_vm._s(_vm.model.justification)),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
            _c("emc-alert-modal", {
              attrs: {
                text: "Após salvar a edição do termo, não será possível editar novamente. Deseja salvar?",
                show: _vm.showSave,
              },
              on: {
                "update:show": function ($event) {
                  _vm.showSave = $event
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "actions",
                  fn: function () {
                    return [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary", loading: _vm.updating },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.save()
                            },
                          },
                        },
                        [
                          _vm._v("Salvar"),
                          _c("v-icon", { attrs: { right: "", dark: "" } }, [
                            _vm._v("mdi-content-save"),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            !_vm.view && !_vm.isFormBlocked
              ? _c(
                  "v-btn",
                  {
                    attrs: { color: "primary" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.showSaveTerm()
                      },
                    },
                  },
                  [
                    _vm._v("Salvar"),
                    _c("v-icon", { attrs: { right: "", dark: "" } }, [
                      _vm._v("mdi-content-save"),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }